import { definePage, type PluginWebManifest } from '@reflex/plugin-api/web';

const page = definePage({
  path: '/configure/connect/ai-gateway',
  label: 'AI Gateways',
  icon: 'Network',
  group: 'security',
  componentPath: '@reflex/plugin-ai-gateway/web/AiGatewaysPage',
  description: 'Proxy agent LLM traffic through Runloop AI Gateways.',
  details:
    'Register Runloop AI Gateway endpoints with stored bearer tokens, then attach a gateway to an agent run so the devbox sends model traffic through it. The bearer stays on the server and agents only see the gateway URL, so you get centralised auth, rate limiting, and observability for upstream LLM calls.',
  features: [
    'Per-org gateway registry with stored bearer tokens',
    'Bearer stays on the server, never reaches the devbox',
    'Attach a gateway to an agent run from the new-agent picker',
    'AI Gateways section on every agent detail page',
    'Gateway resource preview for cross-plugin references',
  ],
});

export const aiGatewayWeb: PluginWebManifest = {
  ...page.web,
  // The standalone /ai-gateways route stays as the daily-use list.
  // Same component also drives setup in the wizard slide-over and
  // the plugin detail page's Setup section.
  orgSetupComponent: {
    componentPath: '@reflex/plugin-ai-gateway/web/AiGatewaysPage',
    label: 'Register an AI gateway so agents can route LLM calls through a shared proxy. Optional.',
  },
  attachments: [
    {
      id: 'ai-gateways',
      label: 'AI Gateways',
      icon: 'Network',
      order: 40,
      pickerComponentPath: '@reflex/plugin-ai-gateway/web/AiGatewayAttachmentPicker',
      summaryComponentPath: '@reflex/plugin-ai-gateway/web/AiGatewayAttachmentSummary',
    },
  ],
  launchMentionProviders: [
    {
      id: 'launch-mention-ai-gateway',
      label: 'AI Gateways',
      keyword: 'gateway',
      icon: 'Network',
      componentPath: '@reflex/plugin-ai-gateway/web/AiGatewayMentionProvider',
      createComponentPath: '@reflex/plugin-ai-gateway/web/AiGatewayMentionCreate',
      createLabel: 'Add AI gateway',
      order: 50,
    },
  ],
  agentDetailSections: [
    {
      id: 'ai-gateways',
      label: 'AI Gateways',
      icon: 'Network',
      componentPath: '@reflex/plugin-ai-gateway/web/AiGatewayDetailSection',
      order: 11,
    },
  ],
  resourcePreviews: [
    {
      kind: 'ai-gateways',
      label: 'AI Gateway',
      icon: 'Network',
      componentPath: '@reflex/plugin-ai-gateway/web/AiGatewayPreview',
      detailHref: '/configure/connect/ai-gateway',
      // The config prefix (`shared/ids.ts`), so a bare `aig_…` id anywhere
      // in the app resolves this preview's icon and hover card.
      idPrefixes: ['aig'],
    },
  ],
  marketingPreviews: [
    {
      id: 'ai-gateways-card',
      label: 'AI Gateways card',
      description: 'Sample gateway registry showing upstream endpoints and ownership.',
      surface: 'card',
      componentPath: '@reflex/plugin-ai-gateway/web/AiGatewaysCardPreview',
    },
  ],
};
